import colors from '@/styles/colors';

export const removeHtmlTags = (str: string) => {
  if (!str) return '';
  return str.replace(/(<([^>]+)>)/gi, '')?.replace(/&nbsp;/g, ' ');
};

export const isValidUSZip = (zip = '') => {
  return /^\d{5}(-\d{4})?$/.test(zip);
};

export const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  const formattedDate = new Date(dateString).toLocaleDateString(
    'en-US',
    options
  );
  return formattedDate;
};

export const InputStyle = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: colors.neutralLight,
    },
    '&:hover fieldset': {
      borderColor: colors.neutralDark,
    },
    '&.Mui-focused fieldset': {
      borderColor: colors.themeLight,
    },
  },
};

export const getHeight = (length: number, phoneView: boolean) => {
  if (length === 0) return phoneView ? '82%' : '75%';
  else if (length === 2 || length === 1) return phoneView ? '75%' : '69%';
  else return phoneView ? '70%' : '65%';
};
